export const UPDATE_SNACKBAR_MESSAGE = 'COMMON.UPDATE_SNACKBAR_MESSAGE';
